/** Built-in stroke icon pack for features-grid blocks (Lucide-derived). */

import {
  FEATURE_ICON_LEGACY_ALIASES,
  GENERATED_FEATURE_ICON_PACK,
} from './featureIconPackData';

export type FeatureIconCategory =
  | 'essentials'
  | 'growth'
  | 'business'
  | 'creative'
  | 'communication'
  | 'marketing';

export type FeatureIconDef = {
  id: string;
  label: string;
  category: FeatureIconCategory;
  /** SVG element markup (stroke icons, 24×24 viewBox). */
  paths: string;
};

export const FEATURE_ICON_CATEGORIES: { id: FeatureIconCategory; label: string }[] = [
  { id: 'essentials', label: 'Essentials' },
  { id: 'growth', label: 'Growth' },
  { id: 'business', label: 'Business' },
  { id: 'creative', label: 'Creative' },
  { id: 'communication', label: 'Communication' },
  { id: 'marketing', label: 'Marketing' },
];

export const FEATURE_ICON_PACK: FeatureIconDef[] = GENERATED_FEATURE_ICON_PACK;

export const FEATURE_ICON_PACK_MAP = Object.fromEntries(
  FEATURE_ICON_PACK.map((icon) => [icon.id, icon])
) as Record<string, FeatureIconDef>;

export function resolveFeatureIconId(id?: string): string | undefined {
  if (!id) return undefined;
  const trimmed = id.trim();
  if (FEATURE_ICON_PACK_MAP[trimmed]) return trimmed;
  const alias = FEATURE_ICON_LEGACY_ALIASES[trimmed];
  if (alias && FEATURE_ICON_PACK_MAP[alias]) return alias;
  return undefined;
}

export function getFeatureIconDef(id?: string): FeatureIconDef | undefined {
  const resolved = resolveFeatureIconId(id);
  if (!resolved) return undefined;
  return FEATURE_ICON_PACK_MAP[resolved];
}
